module.exports = __webpack_public_path__ + "img/icons_16.e30e552e.svg";